export const THEME_DARK = "theme/dark";
export const THEME_LIGHT = "theme/light";
